import CreativeApi from '@/api/Creative'

const getBannersCacheable = () => {
  /** Map<creativeId, Banner>型 */
  const bannersMap = new Map()

  return async creativeId => {
    if (bannersMap.has(creativeId)) {
      return bannersMap.get(creativeId)
    }

    const banner = await CreativeApi.getBanner(creativeId)

    bannersMap.set(creativeId, banner)
    return banner
  }
}

export default getBannersCacheable
